import styled from 'styled-components'

export const Content = styled.p`
  ${({ font }) => font && `font-family: ${font};`}
  ${({ color }) => color && `color: ${color};`}
  font-size: 18px;
  line-height: 23px;
  min-height: 23px;
`
